// src/lib/orgAddress.js
// Organization-address fallback for billing documents.
// Rule: a person's OWN billing address is always authoritative; when it's
// blank and their business matches a Relationship that has an address, the
// relationship's address is used — bill Maria AT the DMV's address. An
// office move fixed once on the relationship flows to everyone blank.
import axios from 'axios';
import { API_BASE } from '../apiBase';

// Deterministic split of a free-text address ("1234 Main St, Sacramento, CA
// 95814") into the Customer.billingAddress shape. Unparseable tails stay in
// street so nothing is lost.
export const parseAddrString = (s) => {
  const raw = String(s || '').trim();
  if (!raw) return null;
  const parts = raw.split(',').map((p) => p.trim()).filter(Boolean);
  const out = { street: parts[0] || raw, city: '', state: '', zip: '', country: 'USA' };
  if (parts.length >= 2) out.city = parts[1];
  for (let i = 2; i < parts.length; i++) {
    const m = /([A-Za-z]{2})\s*(\d{5})?/.exec(parts[i]);
    if (m) { out.state = (m[1] || '').toUpperCase(); if (m[2]) out.zip = m[2]; break; }
  }
  return out;
};

// businessName (lowercased) → parsed relationship address, for print-time
// fallback in the billing builders.
export async function fetchOrgAddressMap() {
  try {
    const { data } = await axios.get(`${API_BASE}/relationships`, {
      headers: { Authorization: localStorage.getItem('token') },
    });
    const map = new Map();
    (data || []).forEach((r) => {
      const key = String(r.company || '').trim().toLowerCase();
      const addr = parseAddrString(r.address);
      if (key && addr) map.set(key, addr);
    });
    return map;
  } catch (_) { return new Map(); }
}

// The address a document should print for this customer.
export const billingAddressFor = (cust, orgMap) => {
  const own = cust && cust.billingAddress;
  if (own && String(own.street || '').trim()) return own;
  const key = String(cust?.businessName || '').trim().toLowerCase();
  return (key && orgMap && orgMap.get(key)) || own || {};
};
